module.exports = __webpack_public_path__ + "static/img/image151.44878ef5.png";